import { BtnSwitch } from './utilities/switch.js';
const exportLayer = require("tpl/newsearch/exportlayer.html");
const referLayer = require("tpl/newsearch/referlayer.html");
const conditionItem = require("tpl/newsearch/conditionitem.html");
const downloadLayer = require("tpl/newsearch/downloadlayer.html");
const exchangeLayer = require("tpl/newsearch/exchange.html");
const Ajax = util.ajax;

const __newSearch = {
    curSelectPaperCount: 0, // 当前选中的文献数量
    // 点击标题显示和隐藏列表
    handleToggleTitle() {
        $(this).parents("._section")
            .find("._listMain").slideToggle()
            .end()
            .find("._titleArrow").toggleClass("ani");
    },
    // 点击收起和显示完整列表
    handleToggleList() {
        $(this).parents("._listMain")
            .find("._currMenuList")
            .toggleClass("ani")
            .end()
            .find("._indicatorText")
            .toggle()
            .end()
            .find("._showFullListArrow").toggleClass("ani");

    },
    // 点击展开和收起树
    handleToggleTree() {
        let currLevel = $(this).attr('data-level');

        // 如果是第一级和第二级点击展开
        if (currLevel == 1 || currLevel == 2) {
            $(this).toggleClass("fe-tree-fold fe-tree-unfold");
            if (currLevel == 1) {
                let $parents = $(this).parents('._levelOneContent');
                // 如果当前是收起列表。点击一级要收起所有的列表，
                // 如果是展开。就只展开二级列表

                if ($(this).hasClass("fe-tree-fold")) {
                    $parents.find('._levelTwoContent,._levelThreeContent').slideUp();
                    $('.fe-tree-unfold').addClass('fe-tree-fold').removeClass('fe-tree-unfold');
                } else {
                    $parents.find('._levelTwoContent').slideDown();
                }
            } else if (currLevel == 2) {
                $(this).parents('._levelTwoContent').find('._levelThreeContent').slideToggle();
            }
        } else {
            // 如果是第三级。就作为赛选条件
        }

    },
    // 点击checkbox选择框操作
    handleClickCheckbox() {
        // type =1 是选择单条数据，2是全选。3是左侧的筛选条件
        let type = $(this).attr('data-type');

        // 如果是全选按钮
        if (type == 2) {
            __newSearch.handleSelectCheckBox.call(this);
            __newSearch.handleCheckedPaper.call(this);
            // 如果是单选
        } else {
            __newSearch.handleSelectCheckBox.call(this);
            // 等于1是单条文献数据
            if (type == 1) {
                if ($(this).hasClass('select')) {
                    __newSearch.curSelectPaperCount += 1;
                } else {
                    __newSearch.curSelectPaperCount -= 1;

                }
            }
        }
    },
    // 选中单选框的操作
    handleSelectCheckBox() {
        let isSelect = $(this).hasClass("select");

        !isSelect ? __newSearch.addSelectState.call(this) : __newSearch.removeCheckedState.call(this);
    },
    // 添加选择框的选中状态
    addSelectState() {
        let checkState = '<i class="iconfont _icon">&#xe813;</i>';
        // 如果当前标签没有被选中。就选中他

        if (!$(this).hasClass('select')) {
            $(this).addClass('select').prepend(checkState);
        }
    },
    // 移除选择框选中状态
    removeCheckedState() {
        // 如果选择框已经被选中了。才移除他
        if ($(this).hasClass('select')) {
            $(this).removeClass('select').find('._icon').remove();
        }
    },
    // 点批量选择全部的列表操作
    handleCheckedPaper() {
        let $list = $('#_searchResultWanfang').find('._selectSinglePaper');
        let selectState = false;

        if ($(this).hasClass('select')) {
            __newSearch.curSelectPaperCount = $list.length;
            selectState = true;
        } else {
            __newSearch.curSelectPaperCount = 0;
            selectState = false;
        }

        $list.each((index, item) => {
            __newSearch.toggleSelectCheckbox.call($(item), selectState);
        });
    },
    // 根据传入的状态。决定是全部选中还是全部不选中
    toggleSelectCheckbox(selectState) {
        selectState ? __newSearch.addSelectState.call(this) : __newSearch.removeCheckedState.call(this);
    },
    // 点击左侧的菜单进行筛选
    handleClickFilter() {
        let $this = $(this);
        let searchType = $this.attr('data-search');
        let type = $this.attr('data-type');
        let key = $this.attr('data-key');
        let name = $this.attr('data-name');

        if (searchType && searchType != '') {
            __newSearch.setKjFileVal($this, name, searchType);
        } else {
            if (type == 1) {
                __newSearch.submitForm.find("input[name=c]").val(key);
            } else {
                __newSearch.setCurrFieldVal.call($this, name, key);
            }

        }
        __newSearch.handleLocationHref();
    },
    searchTime() {
        let startYear = $('._startYear').val(),
            endYear = $('._endYear').val();

        if (startYear > endYear) {
            __newSearch.submitForm.find("input[name=filter_start_year]").val(endYear);
            __newSearch.submitForm.find("input[name=filter_end_year]").val(startYear);
        } else {
            __newSearch.submitForm.find("input[name=filter_start_year]").val(startYear);
            __newSearch.submitForm.find("input[name=filter_end_year]").val(endYear);
        }
        __newSearch.handleLocationHref();
    },
    handleLocationHref() {
        let queryStr = __newSearch.submitForm.serializeArray();
        let _href = '',
            arr = [];

        queryStr.forEach((item) => {
            arr.push(item.name + "=" + encodeURIComponent(item.value));
        });

        _href = arr.join("&");
        window.location.search = "?" + _href;
    },
    setKjFileVal($this, name, searchType) {
        let val = $this.find("._subTitle").text();

        if (searchType == 'filter_start_year') {
            $('#_submitForm').find('input[name=filter_end_year]').val('');
        }
        __newSearch.submitForm.find(`input[name=${searchType}]`).val(val);

    },
    setCurrFieldVal(name, key, isAdd = true) {
        const CORE = "core";
        const SUBJECT = "tzcid";
        let filterNameKey = CORE === name ? CORE : 'q';
        // 获取当前筛选项对应的input。然后把点击的内容添加上去
        let $qField = __newSearch.submitForm.find("input[name=q]");
        let $coreField = __newSearch.submitForm.find("input[name=core]")
        let value = '';

        if (SUBJECT === name || CORE === name) {
            let val = $(this).find("._subTitle").text();

            if (CORE === name) {
                $coreField.val(isAdd ? val : "");
            } else {
                let $subject = __newSearch.submitForm.find("#tzcid");

                if (isAdd) {
                    $subject.val(val).attr("name", "tzcid");
                }
            }
        }
        // 如果是点击的核心。。就同时设置q和core参数
        value = isAdd ? $qField.val() + key : $qField.val().replace(key, '');
        $qField.val(value);
        // 如果是core。就取当前选项内部的标题。否则。就是加上当前的key
    },
    // 点击取消当前选择的筛选条件
    handleCancelCurrFilter() {
        let $parent = $(this).parent();
        let searchType = $parent.attr('data-search');
        let type = +$parent.attr('data-type');
        let key = type === 1 ? '' : $parent.attr('data-key');
        let name = $parent.attr('data-name');

        if (searchType && searchType != '') {
            if (searchType == 'filter_start_year') {
                __newSearch.submitForm.find('input[name=filter_end_year]').val('');
            }
            __newSearch.submitForm.find(`input[name=${searchType}]`).val('');

        } else {
            if (type === 1) {
                __newSearch.submitForm.find("input[name=c]").val('');
            } else {
                __newSearch.setCurrFieldVal.call($parent, name, key, false);
            }
        }

        __newSearch.handleLocationHref();
    },
    // 点击按钮显示文献标题
    handleShowPaperTitle() {
        let $this = $(this);
        let $parent = $this.parents("._currShowLine");
        let id = $this.attr('data-id');
        let $detail = $parent.next();


        // 如果还没有数据。就去请求数据
        if (!$this.attr('data-load')) {
            if ($this.attr('loading')) {
                return false;
            }
            $this.attr('loading', true);
            $this.next().show();
            Ajax({
                url: `/scholarism/ajaxGetElsevierAbstract?eid=${id}`,
                callback({ data }) {
                    let abstrctList =
                        `<tr class = "_titleLine">
                            <td aria-hidden="true"></td>
                            <td colspan = "5" >
                                <div class="current-papar-title">
                                    <div class="detail">
                                        <span>文献摘要:</span>
                                        <p>${data.abstrct}</p>
                                    </div>
                                </div> 
                            </td>
                        </tr>`;

                    $this.removeAttr('loading');
                    $parent.after(abstrctList);
                    $this
                        .addClass('show')
                        .attr('data-load', true)
                        .text('收起摘要')
                        .next().hide();
                }
            });
            _advancedSearch
        } else {
            if ($this.hasClass("show")) {
                $detail.hide();
            } else {
                $detail.show();
            }
            $this.text(!$this.hasClass("show") ? '收起摘要' : '查看摘要');
            $this.toggleClass('show');
        }
    },
    // 显示导出弹窗
    handleShowExportLayer() {
        if (__newSearch.curSelectPaperCount <= 0) {
            layer.msg('请先选择文献');
            return false;
        }
        let selectData = {};
        let $selectList = $('#_searchResultWanfang').find("._selectSinglePaper.select");
        let $exportLayerHTML = '';

        selectData.count = $selectList.length;
        selectData.list = [];
        $selectList.each((index, item) => {
            let $parents = $(item).parents('.item');
            let currData = {
                id: $parents.find('.selectSinglePaper').val(),
                desc: $parents.find('.paper-summary').text()
            };

            selectData.list.push(currData);
        });
        $exportLayerHTML = exportLayer(selectData);
        $("body").append($exportLayerHTML);
    },
    // 显示引用弹窗
    handleShowReferLayer() {
        let $referLayerHTML = referLayer(data);

        $("body").append($referLayerHTML);
    },
    // 删除当前选择的文献
    handleDeleteCurrItem() {
        $(this).parents('._paperItem').remove();

        __newSearch.exportPaperItem -= 1;
        // 如果当前的文献数量小于等于0了。就关闭弹窗
        if (__newSearch.exportPaperItem <= 0) {
            __newSearch.handleCloseLayer.call(this);
        }
    },
    // 导出参考文献
    handleExportCurrPaper() {
        $ajax({
            url: '',
            type: 'post',
            data: {

            },
            callback() {
                return 1;
            }
        });
    },
    // 点击文章进行引用
    handleReferCurrPaper() {
        let range = document.createRange();
        let sel = window.getSelection();


        range.selectNodeContents(this);
        __newSearch.removeReferSelectState();
        sel.addRange(range); // 移除上次选中的范围。再重新进行添加当前选择的范围
        $(this).addClass('selected');
        __newSearch.currSelectedReferName = $(this).text();
        __newSearch.prevSelectedReferItem = $(this);

        document.execCommand('copy');
    },
    // 去掉当前的引用框的引用状态
    removeReferSelectState() {
        let sel = window.getSelection();

        // 先移除掉上一次被选中的引用的选中样式
        if (__newSearch.prevSelectedReferItem) {
            __newSearch.prevSelectedReferItem.removeClass('selected');
        }
        sel.removeAllRanges();
    },
    setCopyData(e) {
        e.originalEvent.clipboardData.setData('text/plain', __newSearch.currSelectedReferName);
        layer.msg('复制成功');
        e.preventDefault();
    },
    cancleReferSelectState(e) {
        if (!$(e.target).hasClass('_paperDesc')) {
            __newSearch.removeReferSelectState();
        }
    },
    // 点击排序
    handleSortCurrOriginTable() {
        let type = $(this).attr('data-type');

        $(this).parents("._originTable").find('.active').removeClass('active');
        $(this).addClass('active');
        $ajax({
            url: '',
            type: 'post',
            data: {
                id: id
            },
            callback(data) {
                __newSearch.renderOriginTable();
            }
        });
    },
    // 点击清理当前选择的文献
    handleClearCurrSelectPaper() {
        var $selectAllBtn = $("._selectTotalPaper");

        __newSearch.removeCheckedState.call($selectAllBtn);
        __newSearch.handleCheckedPaper.call($selectAllBtn);
    },
    // 初始化万方的排序操作
    initWanfangSort() {
        const SORT_BY_YEAR = "YEAR.D";
        const SORT_BY_REF = "RN.D";
        let _href = __newSearch.href;
        let currDefaultIndex = 0;

        if (_href.indexOf("sort") > 0) {
            let sortQuery = /sort=([^&]*)/.exec(_href)[1];

            currDefaultIndex = !sortQuery ? 0 : (sortQuery == SORT_BY_YEAR ? 1 : 2);
        }
        new BtnSwitch({
            activeCls: "active",
            itemCls: '._btnItem',
            parentCls: '._btnList',
            defaultIndex: currDefaultIndex, // 默认显示的元素
            changeIndex(index) {
                let key = '';

                if (index === 1) {
                    key = SORT_BY_YEAR;
                } else if (index === 2) {
                    key = SORT_BY_REF;
                }
                if (_href.lastIndexOf('sort') < 0) {
                    _href += `&sort=${key}`;
                } else {
                    _href = _href.replace(/sort=([^&]*)/, `sort=${key}`);
                }
                window.location.href = _href;
            }
        });
    },
    initWanfangOtherSider(list) {

        let c = __newSearch.submitForm.find("input[name=c]").val();

        Ajax({
            url: `/scholarism/ajaxGetWfSecPart?q=${encodeURIComponent(util.queryString("q"))}&c=${c}`,
            callback({ data }) {
                let currSelectKey = true;
                let qListStr = $("#_submitForm").find("input[name=q]").val();
                let reg = '',
                    match = '',
                    specialKey = { "core": 1, "tzcid": 1 };

                for (let key in data) {
                    let _data = {};

                    data[key] = data[key].filter((item) => {
                        if (item.value) {
                            return item;
                        }
                        return '';
                    });
                    _data = {
                        name: key == 'core' ? "核心期刊" : data[key][0].name,
                        iconName: '',
                        type: 2,
                        key: key,
                        list: data[key] && data[key].slice(0, 10),
                        selectedName: '',
                        isShowFullList: currSelectKey
                    };
                    switch (key) {
                        case "joucn":
                            _data.iconName = 'icon-lingyu';
                            break;
                        case "keyword":
                            _data.iconName = 'icon-ziyuanleixing';
                            break;
                        case "lan":
                            _data.iconName = 'icon-yuzhong';
                            break;
                        case "org":
                            _data.iconName = 'icon-jigou';
                            break;
                        case "year":
                            _data.iconName = 'icon-nianfen';
                            break;
                        case "core":
                            _data.iconName = 'icon-hexin';
                            break;
                        case "tzcid":
                            _data.iconName = 'icon-xuekefenlei';
                            break;
                    }

                    reg = new RegExp("\\s+AND\\s+" + key + ':([^\\s]+)', "ig");
                    match = reg.exec(qListStr);
                    if (match && match.length > 1) {
                        _data.isShowFullList = false;
                        _data.alias = match[0];
                        for (let item in specialKey) {
                            if (specialKey[key]) {
                                let reg = new RegExp(key + "=([^&]*)", "g");
                                let matchInside = reg.exec(__newSearch.href);

                                if (matchInside && matchInside.length > 1) {
                                    _data.selectedName = decodeURIComponent(matchInside[1]);
                                }
                                // 如果没找到
                            } else {
                                _data.selectedName = match[1];
                            }
                        }

                    }

                    list += conditionItem(_data);
                }
                $content.html(list);
                $("#_loadIcon").hide();
            }
        });
    },
    // 分多个部分请求左侧数据
    partLoadSider(field, callback) {
        let c = __newSearch.submitForm.find("input[name=c]").val();
        Ajax({
            url: `/scholarism/ajaxGetWfPart?q=${encodeURIComponent(util.queryString("q"))}&c=${c}&field=${field}`,
            callback({ data }) {
                let currSelectKey = true;
                let qListStr = $("#_submitForm").find("input[name=q]").val();
                let reg = '',
                    match = '',
                    specialKey = { "core": 1, "tzcid": 1 };

                for (let key in data) {
                    let _data = {};

                    data[key] = data[key].filter((item) => {
                        if (item.value) {
                            return item;
                        }
                        return '';
                    });
                    _data = {
                        name: key == 'core' ? "核心期刊" : data[key][0].name,
                        iconName: '',
                        type: 2,
                        key: key,
                        list: data[key] && data[key].slice(0, 10),
                        selectedName: '',
                        isShowFullList: currSelectKey
                    };
                    switch (key) {
                        case "joucn":
                            _data.iconName = 'icon-lingyu';
                            break;
                        case "keyword":
                            _data.iconName = 'icon-ziyuanleixing';
                            break;
                        case "lan":
                            _data.iconName = 'icon-yuzhong';
                            break;
                        case "org":
                            _data.iconName = 'icon-jigou';
                            break;
                        case "year":
                            _data.iconName = 'icon-nianfen';
                            break;
                        case "core":
                            _data.iconName = 'icon-hexin';
                            break;
                        case "tzcid":
                            _data.iconName = 'icon-xuekefenlei';
                            break;
                    }

                    reg = new RegExp("\\s+AND\\s+" + key + ':([^\\s]+)', "ig");
                    match = reg.exec(qListStr);
                    if (match && match.length > 1) {
                        _data.isShowFullList = false;
                        _data.alias = match[0];
                        for (let item in specialKey) {
                            if (specialKey[key]) {
                                let reg = new RegExp(key + "=([^&]*)", "g");
                                let matchInside = reg.exec(__newSearch.href);

                                if (matchInside && matchInside.length > 1) {
                                    _data.selectedName = decodeURIComponent(matchInside[1]);
                                }
                                // 如果没找到
                            } else {
                                _data.selectedName = match[1];
                            }
                        }
                    }
                    callback && callback(_data);
                }
            }
        });
    },
    // 获取万方侧边栏
    getWangFangTypeSider() {
        // 重新加载的时候加上c字段
        Ajax({
            url: `/scholarism/ajaxGetGroupField?c=${util.queryString("c")}`,
            callback({ data }) {
                let $content = $("#_searchPanel");
                let $loadIcon = $("#_loadIcon");
                let totalField = data.length;
                // 用一个额外的currIndex来判断是否加载完了全部列表。因为ajax加载成功的顺序不一定是按照发出的顺序确定的
                let currIndex = 0;

                for (let index = 0; index < data.length; index++) {
                    __newSearch.partLoadSider(data[index], function(data) {
                        // 如果是空数据想。就跳过该项筛选的生成
                        if (data.list && data.list.length) {
                            __newSearch.createSiderGroupItemByData(data);
                        }
                        // 如果全部加载完毕。就隐藏loading按钮
                        currIndex++;
                        if (currIndex === totalField - 1) {
                            $loadIcon.hide();
                        }
                    });
                }
            }
        })
    },
    // 公用的创建左侧菜单组的方法
    createSiderGroupItemByData(data) {
        // 用一个自增的index来给每个组一个唯一的id
        if (!__newSearch.globalIndex) {
            __newSearch.globalIndex = 1;
        }
        data.hasAni = true;
        data.index = __newSearch.globalIndex;
        $("#_loadIcon").before(conditionItem(data));
        // 通过这个唯一的id来做一些操作
        $("#_siderGroupItem" + __newSearch.globalIndex).animate({
            opacity: 1
        }).css({ '-ms-transform': 'translateY(0)', '-webkit-transform': 'translateY(0)', 'transform': 'translateY(0)' });
        __newSearch.globalIndex++;

    },
    // 初始化万方左侧栏
    initWanfangSider() {
        Ajax({
            url: `/scholarism/ajaxGetWfFirPart?q=${encodeURIComponent(util.queryString("q"))}`,
            callback({ data }) {
                let currSelectKey = $("#_submitForm").find("input[name=c]").val();
                let _data = {
                    name: "资源类型",
                    iconName: "icon-ziyuanleixing",
                    type: 1,
                    list: data,
                    key: '',
                    selectedName: data[currSelectKey] && data[currSelectKey].name,
                    isShowFullList: currSelectKey ? false : true
                };
                __newSearch.createSiderGroupItemByData(_data);
                __newSearch.getWangFangTypeSider();
                // __newSearch.initWanfangOtherSider(list);
            }
        });
    },
    // 初始化科界学术左侧栏
    initKjCondit() {
        let $content = $("#_searchPanel"),
            startYear = $('#_submitForm').find('input[name=filter_start_year]').val(),
            endYear = $('#_submitForm').find('input[name=filter_end_year]').val(),
            type = $('#_submitForm').find('input[name=filter_type]').val(),
            keyword = $('#_submitForm').find('input[name=filter_keyword]').val(),
            hexin = $('#_submitForm').find('input[name=filter_hexin]').val(),
            jigou = $('#_submitForm').find('input[name=filter_jigou]').val(),
            qikan = $('#_submitForm').find('input[name=filter_qikan]').val();


        let queryStr = __newSearch.submitForm.serializeArray();
        let submitData = {};

        for (let { name, value } of queryStr) {
            submitData[name] = value;
        }

        Ajax({
            url: '/Searchkj/ajaxGetLeft',
            type: 'get',
            data: submitData,
            callback({ data }) {
                $content.empty();
                for (let key in data) {
                    let _data = {},
                        list = data[key].list;

                    _data = {
                        isShow: false,
                        name: data[key].name,
                        iconName: '',
                        type: 1,
                        key: key,
                        list: list,
                        selectedName: '',
                        isShowFullList: true,
                        isShowTime: false
                    };

                    switch (key) {
                        case "qikan_group":
                            _data.iconName = 'icon-chubanzhuangtai';
                            _data.searchType = 'filter_qikan';
                            if (list.length) {
                                list.forEach((item) => {
                                    if (item.name.trim() == qikan) {
                                        _data.selectedName = qikan;
                                        _data.isShowFullList = false;
                                    }
                                })
                            } else {
                                _data.isShow = true;
                            }

                            break;

                        case "jigou_group":
                            _data.iconName = 'icon-jigou';
                            _data.searchType = 'filter_jigou';
                            if (list.length) {
                                list.forEach((item) => {
                                    if (item.name == jigou) {
                                        _data.selectedName = jigou;
                                        _data.isShowFullList = false;
                                    }
                                })
                            } else {
                                _data.isShow = true;
                            }

                            break;
                        case "year_group":
                            _data.iconName = 'icon-nianfen';
                            _data.isShowTime = true;
                            _data.searchType = 'filter_start_year';
                            if (list.length) {
                                if (endYear && endYear == '') {
                                    list.forEach((item) => {
                                        if (item.name == startYear) {
                                            _data.selectedName = startYear;
                                            _data.isShowFullList = false;
                                        }
                                    })
                                }
                                if (startYear != '' && endYear != '') {
                                    _data.selectedName = startYear + '-' + endYear;
                                    _data.isShowFullList = false;
                                } else if (startYear != '' && endYear == '') {
                                    _data.selectedName = startYear;
                                    _data.isShowFullList = false;
                                } else if (endYear != '' && startYear == '') {
                                    _data.selectedName = endYear;
                                    _data.isShowFullList = false;
                                }

                            } else {
                                _data.isShow = true;
                            }

                            break;
                        case "hexin_group":
                            _data.iconName = 'icon-hexin';
                            _data.searchType = 'filter_hexin';
                            if (list.length) {
                                list.forEach((item) => {
                                    if (item.name == hexin) {
                                        _data.selectedName = hexin;
                                        _data.isShowFullList = false;
                                    }
                                })
                            } else {
                                _data.isShow = true;
                            }

                            break;
                        case "type_group":
                            _data.iconName = 'icon-xuekefenlei';
                            _data.searchType = 'filter_type';
                            if (list.length) {
                                list.forEach((item) => {
                                    if (item.name == type) {
                                        _data.selectedName = type;
                                        _data.isShowFullList = false;
                                    }
                                })
                            } else {
                                _data.isShow = true;
                            }

                            break;
                    }


                    $content.append(conditionItem(_data));
                }
                $("#_loadIcon").hide();
                __newSearch.initKeyWord(submitData, keyword);
                __newSearch.initDate();
            }
        });
    },
    initKeyWord(submitData, keyword) {
        let $content = $("#_searchPanel");

        Ajax({
            url: '/Searchkj/ajaxGetLeftKeyword',
            type: 'get',
            data: submitData,
            callback(res) {
                let data = res.data;


                for (let key in data) {
                    let _data = {},
                        list = data[key].list;

                    _data = {
                        isShow: false,
                        name: data[key].name,
                        iconName: 'icon-ziyuanleixing',
                        type: 1,
                        key: key,
                        list: list,
                        selectedName: '',
                        isShowFullList: true,
                        isShowTime: false,
                        searchType: 'filter_keyword'
                    };

                    if (list.length) {
                        list.forEach((item) => {
                            if (item.name == keyword) {
                                _data.selectedName = keyword;
                                _data.isShowFullList = false;
                            }
                        })
                    } else {
                        _data.isShow = true;
                    }
                    $content.append(conditionItem(_data));
                }
            }
        })
    },
    // 在结果中检索
    handleSeachInRes() {
        let $targetForm = $("#_submitForm");
        let arr = $("#_searchResForm").serializeArray();
        //   AND AU:  AND KEYWORD:
        // 把对应的值赋值到对应的隐藏input中。然后提交Form

        arr.map((item) => {
            let { name, value } = item;
            let $qField = $targetForm.find("input[name=q]");

            if (name === "currtitle" || name === "currauthor" || name === "currkeyword") {
                let qStr = '';
                let reg = '';

                switch (name) {
                    case "currtitle":
                        qStr = ` AND TI:`;

                        break;
                    case "currauthor":
                        qStr = ` AND AU:`;
                        break;
                    case "currkeyword":
                        qStr = ` AND KEYWORD:`;
                        break;
                }
                reg = new RegExp(qStr + "[^&]*");
                // 如果value不为空
                if (value) {
                    let currQVal = $qField.val();
                    let newVal = qStr + value;

                    // 还没有往q里面追加.加插入到q参数中
                    // 如果已经追加了。就替换当前值为新的值
                    $qField.val(reg.test($qField.val()) ? currQVal.replace(reg, newVal) : currQVal + newVal);
                    // 如果value为空。就移除掉当前插入到q中的参数
                } else {
                    $qField.val($qField.val().replace(reg, ""));
                }


            }

            $targetForm.find(`._${name}`).val(value);
            return item;
        });
        $targetForm.submit();
    },
    handleChangePageLimit() {
        let val = $(this).val();

        window.location.href = __newSearch.href.replace(/size=(?:[0-9]{2})/, `size=${val}`);
    },
    handleToggleSearchBtn() {
        let $this = $(this);
        let $next = $this.next();

        $this.val() ? $next.removeAttr('disabled') : $next.attr('disabled', true);
    },
    handleSoreElse() {
        let val = $(this).val();

        window.location.href = __newSearch.href.replace(/sort=(?:[^&]*)/, `sort=${val}`);
    },
    getCurrSelectedCondition() {
        let $content = $("#_condition");
        let box = $content.find('._checkBox.select');
        let arr = {},
            locationArr = [],
            name, value;

        box.each((index, item) => {
            name = $(item).attr('data-name');
            value = $(item).attr('data-value');

            if (arr[name]) {
                arr[name].push(value);
            } else {
                arr[name] = [value];
            }

        });
        for (let item in arr) {
            arr[item] = arr[item].join(",");
            $("#_hiddenForm").find(`input[name=${item}]`).val(arr[item]);
        }

        return arr;
    },
    // 限制搜索结果
    handleLimitRange() {
        let queryStr = '',
            _href = '',
            arr = [];

        __newSearch.getCurrSelectedCondition();
        queryStr = $("#_hiddenForm").serializeArray();
        queryStr.forEach((item) => {
            arr.push(item.name + "=" + encodeURIComponent(item.value));
        });
        _href = arr.join("&");
        window.location.search = "?" + _href;
    },
    // 排除搜索结果
    handleExcludeRange() {
        var $hiddenForm = $("#_hiddenForm");
        var resetFieldName = ["pubyear", "language", "doctype", "exactsrctitle"];

        // 清空当前选择的所有条件。然后重新加载
        for (var item of resetFieldName) {
            $hiddenForm.find(`input[name=${item}]`).val("");
        }
        $hiddenForm.submit();
    },
    // 初始化爱思唯尔
    initElsevier() {
        var $hiddenForm = $("#_hiddenForm");
        var resetFieldName = ["pubyear", "language", "doctype", "exactsrctitle"];
        var val = '';
        var valArr = [];
        var $conditionList = null;

        for (var name of resetFieldName) {
            val = $hiddenForm.find(`input[name=${name}]`).val();

            if (val) {
                $conditionList = $(`#${name}`).find("._checkBox");
                $conditionList.each((index, item) => {
                    // 如果当前已经选择了该项。就把该项变为勾选状态
                    if (val.indexOf($(item).attr("data-value")) > -1) {
                        __newSearch.addSelectState.call($(item));
                    }
                });
            }
        }
    },
    // 初始化万方详情页
    initWanfangDetail() {
        var $referWebsite = $("#referWebsite");
        var $relationPaper = $("#relationPaper");
        var $abstract = $("#_abstractList");
        var abstractDetail = $abstract.text();
        const MAX_LIMIT = 180;

        __newSearch.abstrctDetail = abstractDetail;
        __newSearch.ellipsisAbstract = __newSearch.abstrctDetail.slice(0, 180) + "...";
        if (abstractDetail.length < MAX_LIMIT) {
            $abstract.parents("._abstractContent").find("._toggleShowFull").hide();
        } else {
            $abstract.text(__newSearch.ellipsisAbstract);
        }

        new BtnSwitch({
            activeCls: "active",
            itemCls: '._btnItem',
            parentCls: '._btnList',
            defaultIndex: 0, // 默认显示的元素
            changeIndex(index) {
                if (index === 0) {
                    $referWebsite.show();
                    $relationPaper.hide();
                } else {
                    $relationPaper.show();
                    $referWebsite.hide();
                }
            }
        });
    },
    // 切换摘要简介和全部
    toggleArticleAbstract() {
        var $abstract = $("#_abstractList");
        var $abstractDi = $(this).find("._abstractText");
        var hasSlideDown = $abstractDi.hasClass("slideDown");

        $abstract.text(!hasSlideDown ? __newSearch.abstrctDetail : __newSearch.ellipsisAbstract);
        $abstractDi.text(!hasSlideDown ? "收起" : "查看全部").toggleClass("slideDown").parent().find(".arrow").toggleClass("ani");
    },
    cancleLayer() {
        $(".fe-layer").remove();
    },
    // 积分兑换下载次数
    exchangeByScore() {
        Ajax({
            url: "/scholarism/ajaxGetJifen",
            callback({ data }) {
                __newSearch.cancleLayer();
                $("body").append(exchangeLayer({
                    allScore: data.user_point,
                    needScore: data.need_point
                }));
            }
        })
    },
    // 确认兑换积分
    handleSureExchage() {
        Ajax({
            url: "/scholarism/ajaxExchange",
            type: "post",
            data: {
                index: util.queryString("index"),
                id: util.queryString("id"),
                type: __newSearch.currType
            },
            callback({ data }) {
                // 跳转链接
                __newSearch.cancleLayer();
                layer.msg("兑换成功");
                window.open(data.jump_url, __newSearch.currType == 2 ? "_blank" : "_top");
                __newSearch.setCurrDownloadCount();
            }
        });
    },
    setCurrDownloadCount() {
        // 先获取当前的次数，如果当前次数大于0，表示还有次数。就在成功调用接口后次数减1
        let $currDWCount = $("#_currDownLoadCount");
        let count = $currDWCount.text();

        if (count > 0) {
            $currDWCount.text(count - 1);
        }
    },
    handleReadOnline() {
        // 获取当前的文献下载次数
        __newSearch.commonReqUserInfo.call(this, 2);
        __newSearch.currType = 2;
    },
    // 点击下载文献按钮
    handleDownloadPaper() {
        // 获取当前的文献下载次数
        __newSearch.commonReqUserInfo.call(this, 1);
        __newSearch.currType = 1;
    },
    // 点击下载或者在线阅读前先判断是否还有次数，然后在请求下载
    commonReqUserInfo(type) {
        let $this = $(this);

        if ($this.hasClass("loading")) {
            return false;
        }
        $this.addClass("loading");
        Ajax({
            url: "/scholarism/ajaxCheckAccess",
            data: {
                index: util.queryString("index"),
                id: util.queryString("id"),
                type: type
            },
            callback({ data, code }) {
                switch (+code) {
                    // 未登录
                    case 100010006:
                        window.location.href = `${data.jump_url}?callback=${encodeURIComponent(window.location.href)}`;
                        break;
                        // 如果下载次数用光，就显示提示
                    case 100060086:
                        $("body").append(downloadLayer());
                        break;
                        // 其他未知的情况
                    case 100000002:
                        layer.msg("出现异常情况，请稍后再试~");
                        break;
                        // 成功的情况
                    case 0:
                        window.open(data.jump_url, type == 2 ? "_blank" : "_top");
                        __newSearch.setCurrDownloadCount();
                        break;
                }
                $this.removeClass("loading");
            },
            errorCallback() {
                $this.removeClass("loading");
            }
        })
    },
    init() {
        let activeCls = 'btn-active';
        var $currCountDom = $(".download-tips-content");
        var l;

        if ($currCountDom.length > 0) {
            l = $currCountDom.offset().left;
        }

        __newSearch.href = window.location.href;
        __newSearch.submitForm = $("#_submitForm");
        // 切换条件筛选
        if (__newSearch.href.indexOf("wanfangdetail") > -1) {
            this.initWanfangDetail();
        } else if (__newSearch.href.indexOf('wanfang') > -1) {
            if ($("#_currDataCount").val() > 0) {
                this.initWanfangSort();
                this.initWanfangSider();
            }
        } else if (__newSearch.href.indexOf('elsevier') > -1) {
            this.initElsevier();
        } else if ($('._searchkj').length > 0) {
            // 科界学术搜索条件筛选

            this.initKjCondit();

        }
        Object.defineProperty(__newSearch, "curSelectPaperCount", {
            set(val) {
                const $staticsSelectCount = $("._currSelectedPaperStatic");

                this.value = val;
                this.value > 0 ? $staticsSelectCount.show() : $staticsSelectCount.hide();
                $("#_currSelectPaperCount").text(this.value);
            },
            get() {
                return this.value;
            },
            configurable: true,
            enumerable: true
        });
        Object.defineProperty(__newSearch, "exportPaperItem", {
            set(val) {
                this.value = val;
                $("#_currExportListCount").text(val);
            },
            get() {
                return this.value;
            }
        });
        __newSearch.curSelectPaperCount = 0;
        __newSearch.exportPaperItem = 0;
        $(window).on("scroll", () => {
            let curr = $("html").scrollTop();

            if (curr > 106) {
                $currCountDom.css({ "left": l, "position": "fixed", top: "50px" });
            } else {
                $currCountDom.css({ "left": "940px", "position": "absolute", top: "30px" });
            }
        })
    },
    initDate() {
        laydate.render({
            elem: '._startYear',
            type: 'year'
        });
        laydate.render({
            elem: '._endYear',
            type: 'year'
        });

        __newSearch.initRenderingDate();
    },
    initRenderingDate() {
        let startYear = __newSearch.submitForm.find("input[name=filter_start_year]").val(),
            endYear = __newSearch.submitForm.find("input[name=filter_end_year]").val();

        $('._startYear').val(startYear);
        $('._endYear').val(endYear);
    },
    mourserHandl() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('._measureMore').show();
        } else {
            $(this).addClass('active');
            $('._measureMore').hide();
        }
    }
};

$(() => {
    __newSearch.init();

    $(document)
        // 点击copy的操作
        // .on('copy', __newSearch.setCopyData)
        // 点击的如果不是引用的时候，就移除引用的选中状态
        .on('click', '#_referLayer', __newSearch.cancleReferSelectState)
        // 点击标题显示和隐藏列表
        .on("click", "._listTitle", __newSearch.handleToggleTitle)
        // // 点击收起和显示完整列表
        .on("click", "._showFullList", __newSearch.handleToggleList)
        // 点击清除。
        .on("click", "#clearHasSelectPaper", __newSearch.handleClearCurrSelectPaper)
        // 点击学科分类的列表
        .on("click", "._treeTarget", __newSearch.handleToggleTree)
        // 选中当前文献
        .on("change", "._checkBox", __newSearch.handleClickCheckbox)
        // 输入内容根据内容判断是否可以点击输入框
        .on("input", "#_searchInResult", __newSearch.handleToggleSearchBtn)
        // 点击筛选项操作
        .on("click", "._currFilterBtn", __newSearch.handleClickFilter)
        // 在结果中检索
        .on("click", "#_searchInResBtn", __newSearch.handleSeachInRes)
        // 点击关闭当前选择的筛选条件
        .on("click", "._closeSelectedFilter", __newSearch.handleCancelCurrFilter)
        // 显示文章标题
        .on("click", "._showPaperTitleBtn", __newSearch.handleShowPaperTitle)
        // 显示导出弹窗
        .on("click", "#_showExportLayerBtn", __newSearch.handleShowExportLayer)
        // 显示引用弹窗
        .on("click", "._showReferLayerBtn", __newSearch.handleShowReferLayer)
        // 点击排序
        .on("click", "._sortCurrOriginTable", __newSearch.handleSortCurrOriginTable)
        // 删除当前的参考文献的按钮点击事件
        .on("click", "._deleteCurrPaperItem", __newSearch.handleDeleteCurrItem)
        // 切换不同的输出格式。导出当前的文献
        .on("change", "#_selectExportFormat", __newSearch.handleExportCurrPaper)
        // 点击切换每页显示数据条数
        .on("change", "#_setPageLimit", __newSearch.handleChangePageLimit)
        // 对爱思唯尔数据排序
        .on("change", "#_sortElse", __newSearch.handleSoreElse)
        // 点击当前选择的标题。进行文章的引用
        .on("click", "._paperDesc", __newSearch.handleReferCurrPaper)
        // 限制和排除搜索结果
        .on("click", "#_limitRange", __newSearch.handleLimitRange)
        // 重置搜索结果
        .on("click", "#_excludeRange", __newSearch.handleExcludeRange)
        // 爱思唯尔详情页
        .on("click", "._meuserList", __newSearch.mourserHandl)
        // 切换显示和隐藏详情
        .on("click", "._showAllAbstractBtn", __newSearch.toggleArticleAbstract)
        // 用积分兑换下载次数
        .on("click", "._exchageByScore", __newSearch.exchangeByScore)
        // 确定兑换积分
        .on("click", "._sureExchangeBtn", __newSearch.handleSureExchage)
        // 点击下载文献按钮操作
        .on("click", "#_downloadPaperBtn", __newSearch.handleDownloadPaper)
        // 在线阅读
        .on("click", "#_onlineReadPaperBtn", __newSearch.handleReadOnline)
        .on("click", "._submitTime", __newSearch.searchTime)

});